import * as React from "react";
import { useProductDetailSlots } from "../../../../../../../../../../slots/slots/context.js";
import { useSolutionsEcommContext } from "../../../../../../../context/modules/EcommContent/SolutionsEcommContent/context/SolutionsEcommContext.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const SolutionsDeliveryIndicator = () => {
  const { Slots } = useProductDetailSlots();
  const { activeVariant } = useProductData();
  const { state } = useSolutionsEcommContext();
  const { quantity } = state.configurations;
  if (!Slots.DynamicDeliveryIndicator) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Slots.DynamicDeliveryIndicator,
    {
      deliveryItems: [{ sku: activeVariant.sku, quantity }],
      isExcludedFromCheckout: activeVariant.isExcludedFromCheckout
    }
  );
};
export {
  SolutionsDeliveryIndicator
};
//# sourceMappingURL=SolutionsDeliveryIndicator.js.map
